import React from "react";
import "./layout.css";
import { StaticImage } from "gatsby-plugin-image";

export default function Layout() {
  return (
    <div className="content">
      <StaticImage src="../images/bs-logo.png" alt="logo" />
      <div className="icons-div">
        <StaticImage src="../images/webdev.png" alt="logo" className="icons" />
        <StaticImage src="../images/code.png" alt="logo" className="icons" />
        <StaticImage src="../images/games.png" alt="logo" className="icons" />
        <StaticImage src="../images/about.png" alt="logo" className="icons" />
      </div>
    </div>
  );
}
